'use client';

import { Button } from '@common/components';
import { SvgTextfieldclose } from '@common/icon';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { BANNER_CONTENTS_TYPE } from '@/api';
import { UnauthQueryOptions } from '@/api/v2';
import { CustomLink } from '@/components/atom/CustomLink';
import { LazyImage } from '@/components/client';
import { SELECTOR } from '@/constants';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';

export const ImageFloatingBanner = () => {
  const [isClose, setIsClose] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  const { isWelloApp } = useCheckWelloApp();

  const { data } = useQuery({
    ...UnauthQueryOptions['get:/wello/v2/allows/banner']({
      query: {
        contents_type_cd: BANNER_CONTENTS_TYPE.HOMETOWN_FLOATING,
      },
    }),
  });

  const banner = (data?.context?.contents ?? [])[0];

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const [mainElement, setMainElement] = useState<HTMLElement>();

  useEffect(() => {
    const mainElement = document.getElementById(SELECTOR.MAIN);
    if (mainElement && isMounted) {
      setMainElement(mainElement);
    }
  }, [isMounted]);

  const applyFileUrl = isWelloApp ? banner?.app_file_url : banner?.file_url;
  const applyLinkUrl = isWelloApp ? banner?.app_link_url : banner?.link_url;

  const isNoRender = isClose || !banner || !(applyFileUrl && applyLinkUrl);

  if (isNoRender) return null;

  return mainElement ? (
    createPortal(
      <CustomLink
        className="sticky bottom-70 z-[2] ml-auto mr-20 size-116 rounded-mlarge"
        href={applyLinkUrl}
        target={banner.target_new_yn ? '_blank' : '_self'}
      >
        <section className="relative size-full">
          <LazyImage
            alt="image"
            className="rounded-mlarge"
            height={116}
            src={applyFileUrl}
            width={116}
          />
          <Button
            className="absolute -right-12 -top-12 size-fit p-0"
            theme="sub-text"
            onClick={(e) => {
              e.preventDefault();
              setIsClose(true);
            }}
          >
            <section className="relative flex size-24 items-center justify-center">
              <SvgTextfieldclose className="absolute left-0 top-0 size-full text-Gray-black opacity-100" />
              <div className="size-20 rounded-pill bg-Gray-white" />
            </section>
          </Button>
        </section>
      </CustomLink>,
      mainElement,
    )
  ) : (
    <></>
  );
};
